<script setup>
import { Direction } from '@enums/direction';
import { ref } from 'vue';
import ContentVueEditor from '@components/ContentVueEditor.vue';
import SliderModal from '@components/SliderModal.vue';
import { trans } from '@tools/translation';
import { eventBus } from '@tools/event-bus';
import { FAVORITE_PROPOSAL_EVENT } from '@organisms/constants';

const emit = defineEmits([ 'close' ]);

const props = defineProps({
  isOpened: {
    type: Boolean,
    required: true,
  },
  payload: {
    type: Object,
    default: () => {},
  },
});

const proposalContent = ref('');
const sendMail = ref(false);
const files = ref([]);

const keepEditorFocus = ref(false);

const close = () => {
  emit('close');
  keepEditorFocus.value = false;

  eventBus.dispatchEvent(
    new CustomEvent(FAVORITE_PROPOSAL_EVENT.OFFER_PROPOSAL_TOGGLE_CALLBACK, {
      detail: {},
    }),
  );
};

const saveProposal = () => {
  eventBus.dispatchEvent(
    new CustomEvent(FAVORITE_PROPOSAL_EVENT.OFFER_SAVE_PROPOSAL, {
      detail: {
        hashIds: props.payload.hashIds,
        teamSize: props.payload.teamSize ?? null,
        comment: proposalContent.value,
        sendMail: sendMail.value,
        teamSizeList: props.payload.teamSizeList ?? null,
        attachments: files.value,
      },
    }),
  );

  close();
  proposalContent.value = '';
};
</script>

<template>
  <SliderModal
    :is-open="isOpened"
    :is-closable-from-overlay="false"
    class="slider-offer-proposal"
    @close="close"
  >
    <template #header>
      {{ trans('sliders.offer_proposal.title') }}
    </template>

    <template #body>
      <div class="slider-offer-proposal-content">
        <div class="slider-offer-proposal-content__label">
          {{ trans('sliders.offer_proposal.textarea_label') }}
        </div>

        <div class="input-text">
          <ContentVueEditor
            v-model="proposalContent"
            v-model:attachments="files"
            enable-attachments
            enable-emojis
            :emojis-panel-position="Direction.DOWN"
            :placeholder="trans('sliders.offer_proposal.textarea_placeholder')"
          />
        </div>

        <div class="input-checkbox">
          <input
            id="sendMail"
            v-model="sendMail"
            type="checkbox"
          >
          <label for="sendMail">
            {{ trans('sliders.offer_proposal.send_checkbox_label') }}
          </label>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="slider-offer-proposal-ctas">
        <div class="btn btn--secondary" @click="close()">
          {{ trans('sliders.offer_proposal.cta_cancel') }}
        </div>
        <div
          class="btn btn--primary"
          @click="saveProposal"
        >
          {{ trans('sliders.offer_proposal.cta_send') }}
        </div>
      </div>
    </template>
  </SliderModal>
</template>
